import { render, staticRenderFns } from "./ShippingChargeWarehouse.vue?vue&type=template&id=7635a3dc&"
import script from "./ShippingChargeWarehouse.vue?vue&type=script&lang=ts&"
export * from "./ShippingChargeWarehouse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports